<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 14:19:13
 * @LastEditors: 诺
 * @LastEditTime: 2022-01-13 21:54:44
-->
<template>
  <div class="music" @click.stop="clickMusic">
    <img :class="{ act_animate_rotate_config: isRotate }" :src="`http://assets.rurushishi.com/activies/activityCenter/turntableLottery/bg-music${isRotate ? '' : '-disable'}.png?v=20220120`" alt />
  </div>
</template>
<script>
export default {
  props: {
    audioSrc: {
      type: String,
      default: "",
    },
    autoPlay: {
      type: Boolean,
      default: true,
    },
    bgColor: {
      type: String,
    },
  },
  data() {
    return {
      isRotate: false,
    };
  },
  methods: {
    // 点击音乐开关
    clickMusic() {
      this.$audio.add("bg", this.audioSrc);
      if (this.$audio.bg.getIsPlay()) {
        // 继续播放
        this.$audio.bg.play(null, () => {
          this.isRotate = true;
        });
      } else {
        // 停止播放
        this.$audio.bg.pause(() => {
          this.isRotate = false;
        });
      }
    },
  },
  created() {
    this.$wx.ready(() => {
      if (!this.audioSrc) {
        console.warn("ActBaseMusic组件 缺少audioSrc参数");
        return;
      }
      this.$audio.add("bg", this.audioSrc);
      if (this.autoPlay == false) {
        console.log("ActBaseMusic组件 音乐需手动播放");
      } else {
        this.$audio.bg.pause(() => {
          this.isRotate = false;
        });
        this.$audio.bg.play(null, () => {
          this.isRotate = true;
        });
      }
    });
  },
};
</script>
<style scoped>
.music {
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #fff;
  box-sizing: border-box;
  top: 96px;
  left: 10px;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.music > img {
  width: 30px;
  height: 30px;
}
</style>
